import React, { useEffect, useState } from "react";
import Header from "./../components/Header";
import { Link, useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart, removefromcart } from "./../Redux/Actions/cartActions";
import { getPublicStoreSettings } from "../Redux/Actions/storeSettingActions";
import Loading from "../components/LoadingError/Loading";

const CartScreen = ({ match, location }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const [addingToCart, setAddingToCart] = useState(!!match.params.id);

  const productId = match.params.id;
  const searchParams = new URLSearchParams(location.search);
  const qty = searchParams.get("qty") ? Number(searchParams.get("qty")) : 1;
  const size = searchParams.get("size") || "";
  const color = searchParams.get("color") || "";

  const cart = useSelector((state) => state.cart);
  const { cartItems = [] } = cart;

  const total = cartItems.reduce((a, i) => a + i.qty * i.price, 0);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const addItem = async () => {
      if (!productId) {
        setAddingToCart(false);
        return;
      }

      try {
        setAddingToCart(true);
        await dispatch(addToCart(productId, qty, size, color));
      } catch (error) {
        alert(error.message || "No se pudo agregar el producto al carrito");
        history.push(`/products/${productId}`);
      } finally {
        setAddingToCart(false);
      }
    };

    addItem();
  }, [dispatch, history, productId, qty, size, color]);

  useEffect(() => {
    dispatch(getPublicStoreSettings());
  }, [dispatch]);

  const removeFromCartHandle = (variantKey) => {
    dispatch(removefromcart(variantKey));
  };

  const formatCOP = (value) =>
    new Intl.NumberFormat("es-CO", {
      style: "decimal",
      maximumFractionDigits: 0,
    }).format(Number(value || 0));

  const goToSummary = () => {
    if (!cartItems.length) return;
    history.push("/cart-summary");
  };

  return (
    <>
      <Header />

      <div className="container">
        {addingToCart ? (
          <div className="mt-4">
            <Loading />
          </div>
        ) : cartItems.length === 0 ? (
          <div
            className="alert text-center mt-3"
            style={{ backgroundColor: "#ebb3b3", borderColor: "#ebb3b3" }}
          >
            Tu carrito está vacío
            <Link
              className="btn btn-success mx-5 px-5 py-3"
              to="/"
              style={{
                fontSize: "12px",
                backgroundColor: "#A30003",
                borderColor: "#A30003",
              }}
            >
              COMPRAR AHORA
            </Link>
          </div>
        ) : (
          <>
            <div className="alert alert-info text-center mt-3">
              Total de productos en el carrito
              <Link className="text-success mx-2" to="/cart">
                ({cartItems.length})
              </Link>
            </div>

            {cartItems.map((item) => (
              <div className="cart-iterm row" key={item.variantKey}>
                <div
                  onClick={() => removeFromCartHandle(item.variantKey)}
                  className="remove-button d-flex justify-content-center align-items-center"
                >
                  <i className="fas fa-times"></i>
                </div>

                <div className="cart-image col-md-3">
                  <img src={item.image} alt={item.name} />
                </div>

                <div className="cart-text col-md-5 d-flex align-items-center">
                  <div>
                    <Link to={`/products/${item.product}`}>
                      <h4>{item.name}</h4>
                    </Link>

                    {item.size && (
                      <small className="d-block text-muted">
                        Talla: {item.size}
                      </small>
                    )}

                    {item.color && (
                      <small className="d-block text-muted">
                        Color: {item.color}
                      </small>
                    )}
                  </div>
                </div>

                <div className="quantity-control-cart">
                  <button
                    type="button"
                    className="quantity-btn-cart"
                    onClick={() =>
                      dispatch(
                        addToCart(
                          item.product,
                          Math.max(1, item.qty - 1),
                          item.size,
                          item.color
                        )
                      )
                    }
                    disabled={item.qty <= 1}
                  >
                    −
                  </button>

                  <span className="quantity-value-cart">{item.qty}</span>

                  <button
                    type="button"
                    className="quantity-btn-cart"
                    onClick={() =>
                      dispatch(
                        addToCart(
                          item.product,
                          Math.min(5, item.qty + 1),
                          item.size,
                          item.color
                        )
                      )
                    }
                    disabled={item.qty >= 5}
                  >
                    +
                  </button>
                </div>

                <div className="cart-price mt-3 mt-md-0 col-md-2 d-flex flex-column justify-content-center col-sm-7">
                  <h6>PRECIO</h6>
                  <h4>${formatCOP(item.price)}</h4>
                </div>
              </div>
            ))}

            <div className="total">
              <span className="sub">total:</span>
              <span className="total-price">${formatCOP(total)}</span>
            </div>

            <hr className="my-1" />

            <div className="cart-buttons">
              <Link to="/" className="cart-btn-left">
                <button className="btn-back">Volver a la tienda</button>
              </Link>

              <div className="cart-btn-right">
                <button className="btn-checkout" onClick={goToSummary}>
                  Realizar compra
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default CartScreen;